import React, { Component } from 'react';
import { logoutAction } from '../../redux/actions/UserActions';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, CardBody, FormGroup, Table } from 'reactstrap';
import Loading from '../Loading';
import { toast } from 'react-toastify';
import { addExpense, listPendingExpenses, deleteExpense } from '../../services/RemisionServices';

class ModalAddExpenseRemitter extends Component {
    state = {
        amount: '',
        name: '',
        loading: false,
        expenses: [],
        total: 0
    }

    componentDidMount = () => {
        toast.configure();
        document.getElementById("amount").focus();
        this.fetchPendingExpenses();
    }

    fetchPendingExpenses = async () => {
        await this.setState({ loading: true });
        try {
            let response = await listPendingExpenses({
                token: this.props.sessionProps.account.token,
                id_remitter: this.props.remitter.value
            });
            await this.setState({
                loading: false,
                expenses: response.data.data,
                total: response.data.total
            });
        } catch (error) {
            await this.setState({ loading: false });
            if (error !== undefined && error.response !== undefined && error.response.status === 401) {
                this.props.logout();
                this.props.history.push('/');
            }
        }
    }

    addAmount = async () => {
        if (this.state.amount === '' || parseFloat(this.state.amount) <= 0) {
            toast.error(`Debe agregar un monto`, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 10000
            });
            return;
        }
        let amount = this.state.amount;
        await this.setState({ loading: true });
        try {
            let data = {
                token: this.props.sessionProps.account.token,
                id_remitter: this.props.remitter.value,
                amount: amount
            };
            if (this.state.name.trim() !== '') {
                data.name = this.state.name.trim();
            }
            let response = await addExpense(data);
            toast(response.data.message, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 5000
            });
            await this.setState({ loading: false, amount: '', name: '' });
            document.getElementById("amount").focus();
            this.fetchPendingExpenses();
            this.props.onUpdated && this.props.onUpdated();
        } catch (error) {
            await this.setState({ loading: false });
            if (error !== undefined && error.response !== undefined && error.response.status === 401) {
                this.props.logout();
                this.props.history.push('/');
            }
            else {
                let msg = 'Ocurrió un error al procesar la solicitud, reintentar.';
                if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
                    msg = error.response.data.message || msg;
                }
                toast.error(msg, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    pauseOnHover: false,
                    duration: 10000
                });
            }
        }
    }

    removeExpense = async (item) => {
        if (!window.confirm(`¿Desea eliminar el gasto "${item.name || 'Genérico'}"?`)) {
            return;
        }
        await this.setState({ loading: true });
        try {
            let response = await deleteExpense({
                token: this.props.sessionProps.account.token,
                id: item.id
            });
            toast(response.data.message, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 5000
            });
            await this.setState({ loading: false });
            this.fetchPendingExpenses();
            this.props.onUpdated && this.props.onUpdated();
        } catch (error) {
            await this.setState({ loading: false });
            if (error !== undefined && error.response !== undefined && error.response.status === 401) {
                this.props.logout();
                this.props.history.push('/');
            }
            else {
                let msg = 'Ocurrió un error al procesar la solicitud, reintentar.';
                if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
                    msg = error.response.data.message || msg;
                }
                toast.error(msg, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    pauseOnHover: false,
                    duration: 10000
                });
            }
        }
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.addAmount()
        }
        if (e.keyCode === 27) {
            this.close();
        }
    }

    close = () => {
        this.props.close();
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div className="container-modal">
                {this.state.loading && <Loading />}
                <div className="content-modal">
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <div onClick={() => this.close()} style={{ textAlign: 'right', cursor: 'pointer' }}>
                                            X
                                        </div>
                                        <div>
                                            <h4>Gestionar gastos del remitente #{this.props.remitter.label}</h4>
                                        </div>
                                        <div className="table-responsive" style={{ marginTop: '1rem' }}>
                                            <Table className="mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Concepto</th>
                                                        <th className="text-right">Monto pendiente</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.expenses.length === 0 &&
                                                        <tr>
                                                            <td colSpan={3} className="text-center">Sin gastos pendientes</td>
                                                        </tr>
                                                    }
                                                    {
                                                        this.state.expenses.map((item, index) =>
                                                            <tr key={item.id || index}>
                                                                <td>{item.name || 'Genérico'}</td>
                                                                <td className="text-right">{parseFloat(item.amount) - parseFloat(item.amount_paid || 0)}</td>
                                                                <td className="text-right">
                                                                    <button type="button" className="btn btn-sm btn-danger"
                                                                        onClick={() => this.removeExpense(item)}>Eliminar</button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th>Total</th>
                                                        <th className="text-right">{this.state.total}</th>
                                                        <th></th>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                        <div style={{ marginTop: '1rem' }}>
                                            <div className="form-group">
                                                <label>Nombre/Concepto</label>
                                                <input type="text" className="form-control" placeholder="Ej: Transporte, Flete, Comisión bancaria"
                                                    name="name" value={this.state.name} onChange={this.handleChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>Monto</label>
                                                <input type="text" className="form-control" placeholder="Ingrese monto"
                                                    name="amount" id="amount" onKeyDown={(e) => { this.onKeyDown(e) }}
                                                    value={this.state.amount} onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <FormGroup className="mb-0 text-right" style={{ marginTop: '1rem' }}>
                                            <div>
                                                <button onClick={() => this.close()} type="button" className="btn btn-secondary">Cerrar</button>
                                                <button onClick={() => this.addAmount()} style={{ marginLeft: '0.5rem' }} className="btn btn-primary">Agregar</button>
                                            </div>
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sessionProps: state.userReducer
});

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logoutAction());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddExpenseRemitter);
